export default __webpack_public_path__ + "static/media/wave.4f0c824f.svg";